import { render, staticRenderFns } from "./TreinamentosVslBooster.vue?vue&type=template&id=0ba3c701&"
import script from "./TreinamentosVslBooster.vue?vue&type=script&lang=js&"
export * from "./TreinamentosVslBooster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports